//@flow
import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import FormField from '../../FormField';
import CustomTextField from '../../../../../../elements/CustomTextField/CustomTextField';
import {colors} from '../../../../../../assets/styles/colors';
import {useFormContext} from 'react-hook-form';
import {BLOG_FORM_FIELDS} from '../../../../constants';
import {getImageUrl} from '../../../../../../utils/image_provider';
import {useStoreDomain} from '../../../../../store/utils';
import {useBlogFormDraftValue} from '../../../../utils/blog-post';

const useStyles = makeStyles(theme => ({
  formSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem',
    borderRadius: '.75rem',
    background: 'white',
  },
  preview: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    width: '100%',
    height: '140px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25);',
    padding: '1rem',
    borderRadius: '.5rem',
    maxWidth: '800px',
    border: `1px solid ${colors.grey300}`,
  },
  information: {
    flexGrow: 1,
  },
  url: {
    fontSize: '.75rem',
    color: '#717190',
  },
  title: {
    color: '#2E24A3',
    fontWeight: 600,
    fontSize: '14px',
  },
  description: {
    color: '#717190',
    fontSize: '.75rem',
  },
  mainImage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    aspectRatio: '16/9',
    overflow: 'hidden',
    borderRadius: '.75rem',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.75rem',
    margin: '1rem 0 .5rem 0',
  },
  tip: {
    fontSize: '.75rem',
    color: colors.grey600,
  },
}));

export default function SeoSection() {
  const classes = useStyles();

  const {register, watch} = useFormContext();
  const {updateDraft} = useBlogFormDraftValue();

  const {domain} = useStoreDomain();

  const poster = watch(BLOG_FORM_FIELDS.poster);
  const title = watch(BLOG_FORM_FIELDS.title);
  const seoTitle = watch(BLOG_FORM_FIELDS.seoTitle);
  const seoDescription = watch(BLOG_FORM_FIELDS.seoDescription);

  const posterUrl =
    typeof poster === 'string'
      ? getImageUrl(poster)
      : poster && URL.createObjectURL(poster);

  return (
    <section className={classes.formSection}>
      <FormField title="7. SEO de la entrada (opcional)">
        <div className={classes.preview}>
          <div className={classes.information}>
            <Typography className={classes.url}>
              {`https://${domain.domainName}/blog/`}
            </Typography>
            <Typography className={classes.title}>
              {seoTitle || title}
            </Typography>
            <Typography className={classes.description}>
              {seoDescription}
            </Typography>
          </div>
          <picture className={classes.mainImage}>
            <img src={posterUrl} alt="" />
          </picture>
        </div>
        <div className={classes.form}>
          <CustomTextField
            placeholder="Título"
            name={BLOG_FORM_FIELDS.seoTitle}
            inputRef={register}
            onBlur={e =>
              updateDraft({[BLOG_FORM_FIELDS.seoTitle]: e.target.value})
            }
          />
          <CustomTextField
            placeholder="Descripción"
            name={BLOG_FORM_FIELDS.seoDescription}
            inputRef={register}
            multiline
            rowsMax={4}
            rows={4}
            onBlur={e =>
              updateDraft({
                [BLOG_FORM_FIELDS.seoDescription]: e.target.value,
              })
            }
          />
        </div>
        <Typography className={classes.tip}>
          Se recomienda utilizar menos de 80 caractéres para el título y menos
          de 160 caractéres para la descripción.
        </Typography>
      </FormField>
    </section>
  );
}
